document.addEventListener('DOMContentLoaded', function () {
    var containers = document.querySelectorAll('.tabbed-bubbles');

    for (var i = 0; i < containers.length; i++) {
        initTabbedBubbles(containers[i]);
    }

    function initTabbedBubbles(container) {
        var buttons = container.querySelectorAll('.tabbed-bubbles__tab-btn');
        var panels = container.querySelectorAll('.tabbed-bubbles__panel');

        for (var j = 0; j < buttons.length; j++) {
            buttons[j].addEventListener('click', handleClick);
        }

        function handleClick() {
            var tabIndex = this.getAttribute('data-tab');

            for (var k = 0; k < buttons.length; k++) {
                buttons[k].classList.remove('tabbed-bubbles__tab-btn--active');
            }
            this.classList.add('tabbed-bubbles__tab-btn--active');

            for (var k = 0; k < panels.length; k++) {
                if (panels[k].getAttribute('data-panel') === tabIndex) {
                    panels[k].classList.add('tabbed-bubbles__panel--active');
                } else {
                    panels[k].classList.remove('tabbed-bubbles__panel--active');
                }
            }
        }
    }
});
